import * as actionTypes from './actionTypes';

export const toggleUpdateRule=()=>({
    type:actionTypes.TOGGLE_UPDATE_RULE
})